module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("form-group " + _vm.formGroupClass + " " + ((_vm.error) ? 'has-danger' : ''))
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    class: ("help-block red-600 " + _vm.errorTextClass)
  }, [_vm._v(_vm._s(_vm.error))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b2b5510!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormGroup.vue
// module id = 536
// module chunks = 1